// Підписка користувача (users/{chatId}) — єдине місце правил для застосунку.
//
//   Стандарт — прибирає водяний знак, і все.
//   Преміум  — ще й перекази (на картки інших банків, між користувачами, між
//              своїми картками), купівля валюти, відкриття нових (зокрема
//              валютних) карток, перегляд PDF квитанції й посилання на неї.
// Без Преміуму ці кнопки просто не реагують на натискання.
//
// Рівень пише бот (subscriptionTier: 'standard' | 'premium'); старі підписки
// без рівня — Стандарт.

// Дата завершення в будь-якому форматі, як у боті (bot/subutil.js):
// ISO, мілісекунди або «ДД.ММ.РРРР [ГГ:ХХ]». 0 — не вдалося розпізнати.
function parseEndMs(val) {
  if (val === null || val === undefined || val === '') return 0;
  if (typeof val === 'number') return Number.isFinite(val) ? val : 0;
  const s = String(val).trim();
  const iso = Date.parse(s);
  if (!Number.isNaN(iso)) return iso;
  const m = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})(?:[ T](\d{1,2}):(\d{2}))?/);
  if (m) {
    const t = Date.UTC(+m[3], +m[2] - 1, +m[1], m[4] !== undefined ? +m[4] : 23, m[5] !== undefined ? +m[5] : 59, 59);
    return Number.isNaN(t) ? 0 : t;
  }
  return 0;
}

// Чи діє будь-яка підписка зараз: безстрокова; статус без дати; або дата в майбутньому
export function hasActiveSubscription(user) {
  if (!user?.subscriptionStatus) return false;
  if (user.subscriptionStatus === 'lifetime' || !user.subscriptionEndDate) return true;
  return parseEndMs(user.subscriptionEndDate) > Date.now();
}

// Тимчасовий бонусний Преміум поверх Стандарту (premiumBoostUntil, ISO)
const hasPremiumBoost = (user) => parseEndMs(user?.premiumBoostUntil) > Date.now();

export function subscriptionTier(user) {
  if (!hasActiveSubscription(user)) return null;
  return user.subscriptionTier === 'premium' || hasPremiumBoost(user) ? 'premium' : 'standard';
}

export const hasPremium = (user) => subscriptionTier(user) === 'premium';
